/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Tooltip_Techdescription2Inputs */

const id_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`daftar teknologi untuk melacak mesin yang digunakan dan berbagai teknologi dari file game.`)
};

const ms_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`senarai teknologi untuk menjejak enjin yang digunakan dan pelbagai teknologi daripada fail permainan.`)
};

const da_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`teknologiliste til at spore de anvendte spilmotorer og forskellige teknologier fra spilfilerne.`)
};

const de_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologieliste zur Verfolgung der verwendeten Engines und verschiedener Technologien aus den Spieldateien.`)
};

const en_us2_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`technologies list to track the used engines and different technologies from the game files.`)
};

const es_es2_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lista de tecnologías para rastrear los motores utilizados y las diferentes tecnologías de los archivos del juego.`)
};

const es_mx2_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lista de tecnologías para rastrear los motores utilizados y las diferentes tecnologías de los archivos del juego.`)
};

const fil_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`listahan ng mga teknolohiya para subaybayan ang mga ginamit na engine at iba't ibang teknolohiya mula sa mga file ng laro.`)
};

const fr_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`liste des technologies pour suivre les moteurs utilisés et les différentes technologies depuis les fichiers du jeu.`)
};

const it_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`elenco delle tecnologie per tracciare i motori utilizzati e le diverse tecnologie dai file di gioco.`)
};

const hu_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`technológiák listája a használt motorok és különböző technológiák követéséhez a játékfájlokból.`)
};

const nl_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`technologieënlijst om de gebruikte engines en verschillende technologieën uit de gamebestanden te volgen.`)
};

const no_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`teknologiliste for å spore motorene som brukes og ulike teknologier fra spillfilene.`)
};

const pl_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lista technologii do śledzenia używanych silników i różnych technologii z plików gry.`)
};

const pt_br2_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lista de tecnologias para rastrear os motores usados ​​e diferentes tecnologias dos arquivos do jogo.`)
};

const pt_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lista de tecnologias para monitorizar os motores usados e as diferentes tecnologias dos ficheiros do jogo.`)
};

const ro_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lista de tehnologii pentru urmărirea motoarelor utilizate și a diferitelor tehnologii din fișierele jocului.`)
};

const fi_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`teknologialista pelitiedostojen käyttämien moottorien ja eri teknologioiden seurantaan.`)
};

const sv_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`teknologilista för att spåra de använda motorerna och olika teknologier från spelfilerna.`)
};

const vi_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`danh sách công nghệ để theo dõi các engine và công nghệ khác nhau từ tệp game.`)
};

const tr_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oyun dosyalarından kullanılan motorları ve farklı teknolojileri izlemek için teknoloji listesi.`)
};

const cs_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seznam technologií pro sledování použitých enginů a různých technologií ze souborů hry.`)
};

const bg_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`списък с технологии за проследяване на използваните енджини и различни технологии от файловете на играта.`)
};

const ru_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список технологий для отслеживания используемых игровых движков и различных технологий на основе файлов игры.`)
};

const uk_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`список технологій для відстеження використаних рушіїв та різних технологій з ігрових файлів.`)
};

const ar_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة التقنيات لتتبع المحركات المستخدمة والتقنيات المختلفة من ملفات اللعبة.`)
};

const hi_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गेम फ़ाइलों से उपयोग किए गए इंजनों और विभिन्न तकनीकों को ट्रैक करने के लिए तकनीकों की सूची।`)
};

const th_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการเทคโนโลยีเพื่อติดตามเอนจินที่ใช้และเทคโนโลยีต่าง ๆ จากไฟล์เกม`)
};

const ja_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームファイルから使用されているエンジンや様々なテクノロジーを追跡するテクノロジ一覧。`)
};

const zh_cn2_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用于追踪游戏文件中使用的引擎及相关技术栈的技术列表。`)
};

const zh_hant1_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用於追蹤遊戲檔案中使用的引擎及相關技術棧的技術清單。`)
};

const ko_offerdetail_tooltip_techdescription2 = /** @type {(inputs: Offerdetail_Tooltip_Techdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 파일에서 사용된 엔진과 다양한 기술을 추적하는 기술 목록입니다.`)
};

/**
* | output |
* | --- |
* | "technologies list to track the used engines and different technologies from the game files." |
*
* @param {Offerdetail_Tooltip_Techdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_tooltip_techdescription2 = /** @type {((inputs?: Offerdetail_Tooltip_Techdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Tooltip_Techdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "ms") return ms_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "da") return da_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "de") return de_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "fil") return fil_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "fr") return fr_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "it") return it_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "hu") return hu_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "nl") return nl_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "no") return no_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "pl") return pl_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "pt") return pt_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "ro") return ro_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "fi") return fi_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "sv") return sv_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "vi") return vi_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "tr") return tr_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "cs") return cs_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "bg") return bg_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "ru") return ru_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "uk") return uk_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "ar") return ar_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "hi") return hi_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "th") return th_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "ja") return ja_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_tooltip_techdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_tooltip_techdescription2(inputs)
	return ko_offerdetail_tooltip_techdescription2(inputs)
});
export { offerdetail_tooltip_techdescription2 as "offerDetail.tooltip.techDescription" }